import { DataLoader } from '../../../core/types/data-loader';
import { StateStore } from '../../../core/types/application-state';
import { parseCurrentQueryString, withDefault } from '../../../core/util';
import { houseHoldSummitData } from '../../shared/summit.utils';
import { getCustomerDataById } from '../../shared/services/customer-service';
import { getCustomerHouseholdDataById } from '../../shared/services/household-service';
import { loadFONASUCustomerData } from '../shared/loaders';
import {
  accountTypes,
  chargeTypes,
  fundingTypes,
  applicationStatusTypes,
  consumerTypes
} from '../../shared/utils';
import { isMailingAddressDifferent } from '../shared/utils';

export const makeLoadTaxableData: DataLoader = async (): Promise<StateStore> => {
  const qs = parseCurrentQueryString();
  const { bpId } = qs;

  const householdData = await getCustomerHouseholdDataById(Number(bpId));

  const summitData = houseHoldSummitData(householdData);

  const customerData = await getCustomerDataById(Number(bpId));

  const customerDataConverted = loadFONASUCustomerData(customerData);

  const mailingAddressDifferent = isMailingAddressDifferent(
    customerDataConverted
  );

  const usernameExists = !!customerData?.username?.length;

  return {
    app: {
      applicationStatus: applicationStatusTypes.PUSH_TO_WEB,
      fundingType: fundingTypes.CHECK,
      chargeType: chargeTypes.NEW,
      customer: customerDataConverted,
      newInvestments: []
    },
    accountType: accountTypes.INDIVIDUAL,
    mailingAddressDifferent,
    loadedData: {
      infoValid: false,
      portfolioValid: false,
      usernameExists,
      fundingValid: false,
      loginID: withDefault(customerData?.username, ''),
      error: '',
      customerInfoEditMode: true,
      portfolioEditMode: false,
      fundingEditMode: false,
      associateLoginID: ''
    },
    summitData,
    consumerName: consumerTypes.FONASU,
    progressStep: 4,
    progressStepText: '4577a9'
  };
};
